import { render, staticRenderFns } from "./SharedLinkRestoreNotFound.vue?vue&type=template&id=e3da8564&scoped=true&"
import script from "./SharedLinkRestoreNotFound.vue?vue&type=script&lang=js&"
export * from "./SharedLinkRestoreNotFound.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkRestoreNotFound.vue?vue&type=style&index=0&id=e3da8564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da8564",
  null
  
)

export default component.exports